// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"12542bed","361":"c0a6440c","453":"76ba2474","752":"ba269646"}[chunkId] + ".chunk.js";
};